const competitorAnalysisManifest = {
  featureId: "competitor_analysis_view",
  serviceKey: "competitor_analysis",
  name: "Competitor Analysis",
  description: "Multi-step AI workflow for strategic market research",
  mode: "workflow",

  steps: [
    {
      id: "research_methodology",
      title: "Research Methodology",
      description: "Defining research approach and competitive landscape",
      status: "pending",
      agentKey: "UX_RESEARCH",
      estimatedDuration: 45,
      loadingMessages: [
        "Defining research methodology...",
        "Mapping the competitive landscape...",
        "Identifying key research dimensions...",
        "Setting up analysis framework...",
        "Preparing competitive criteria...",
      ],
    },
    {
      id: "market_intelligence",
      title: "Market Intelligence",
      description: "Gathering competitor data and market signals",
      status: "pending",
      agentKey: "UX_RESEARCH",
      estimatedDuration: 90,
      loadingMessages: [
        "Gathering competitor data...",
        "Analyzing market positioning...",
        "Researching pricing and features...",
        "Identifying market trends...",
        "Compiling market intelligence...",
      ],
    },
    {
      id: "opportunity_analysis",
      title: "Opportunity Analysis",
      description: "Identifying strategic opportunities",
      status: "pending",
      agentKey: "DESIGN_LEAD",
      estimatedDuration: 60,
      loadingMessages: [
        "Analyzing competitive gaps...",
        "Identifying market opportunities...",
        "Evaluating differentiation potential...",
        "Mapping opportunity spaces...",
        "Prioritizing strategic options...",
      ],
    },
    {
      id: "report_synthesis",
      title: "Report Synthesis",
      description: "Synthesizing findings into actionable insights",
      status: "pending",
      agentKey: "DESIGN_LEAD",
      estimatedDuration: 90,
      loadingMessages: [
        "Synthesizing research findings...",
        "Formulating strategic recommendations...",
        "Building actionable insights...",
        "Crafting your competitive report...",
        "Finalizing analysis summary...",
      ],
    },
  ],

  outputs: [
    "competitor_profiles",
    "market_trends",
    "opportunity_map",
    "strategic_recommendations",
  ],

  intro: "🔍 Starting Competitor Analysis...",
  completion:
    "✅ **Competitor Analysis Complete!** Your market research report is ready.",
};

module.exports = competitorAnalysisManifest;
